import React, { Component } from "react";
import "./CardViewStyles.css";
import Card from "./Card";
import { values } from "lodash";
import SelectionListDropDown from "../../Common/SelectionListDropDown";
import _ from "lodash";
import momentTz from "moment-timezone";
import { versionInfo } from "../../MainPage/VersionInfo";
// import BlueCardViewContainer from "../../AssetView/BlueCard/InitaializeBlueCard/InitializeBluecard";
class AssetsCardView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      assetsList: this.props.assetsList,
      filteredAssets: this.props.assetsList,
      attributesList: this.props.attributesList ? this.props.attributesList : [],
      searchStr: "",
      selectedAsset: null,
    };

    this.handleSearch = this.handleSearch.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (!_.isEqual(prevProps.assetsList, this.props.assetsList)) {
      this.setState({
        assetsList: this.props.assetsList,
        filteredAssets: this.props.assetsList,
        attributesList: this.props.attributesList ? this.props.attributesList : [],
      });
    }
  }
  handleSearch(e) {
    const searchStr = e.target.value;
    const lowerCaseSearchStr = searchStr.toLowerCase();
    const filteredAssets = this.state.assetsList
      ? this.state.assetsList.filter((asset) => !searchStr || asset.unitId.toLowerCase().includes(lowerCaseSearchStr))
      : [];

    this.setState({
      filteredAssets: filteredAssets,
    });
  }

  render() {
    const { selectedAsset } = this.state;
    return (
      <div style={{ display: "flex", flexDirection: "column", justifyContent: "flex-start", alignItems: "flex-start", gap: "15px" }}>
        <input
          style={{ borderRadius: "7px", marginLeft: "20px", padding: "10px 10px", border: "2px solid var(--nine)", marginBlockEnd: "10px" }}
          placeholder={`Search Asset...`}
          onChange={(e) => this.handleSearch(e)}
        />
        <div className="cv_container">
          {this.state.filteredAssets &&
            this.state.filteredAssets.map((e, i) => {
              const { assetStates } = e && e;
              let initialized = assetStates && assetStates.autoBlueCardInitialize;
              return (
                <Card
                  data={getCardData(e, this.state.attributesList)}
                  key={i}
                  handleAssetView={this.props.handleAssetView}
                  assetData={e}
                  showBlueCardIcon={!initialized}
                  handleBlueCardInitialize={this.props.handleBluecardInitialize}
                />
              );
            })}
        </div>{" "}
      </div>
    );
  }
}

export default AssetsCardView;

const getCardData = (asset, attributesList) => {
  if (versionInfo.isReVAMP()) {
    const HeaderDataList = [
      { key: "unitId", name: "Asset Name", value: asset.unitId },
      { key: "assetType", name: "Asset Type", value: asset.assetType },
      { key: "locationName", name: "Location", value: asset.locationName },
      { key: "engineHour", name: "Engine Hours", value: asset && asset.assetStates ? asset.assetStates.engineHour : 0 },
      ...processAttributesList(attributesList, asset, true),
    ];

    const AttributesList = processAttributesList(attributesList, asset, false);

    let order = ["Asset Info", "Attributes"];

    let assetStates = { dailyDue: false, nonCompliant: false, outOfUse: false };
    if (asset.assetStates) {
      const { nonCompliant } = asset.assetStates;
      if (nonCompliant) {
        assetStates.nonCompliant = true;
      }

      const dailyDueDate = asset.assetStates.dailyDue;
      const startOfDay = momentTz.tz("US/Eastern").startOf("day").format();
      const endOfDay = momentTz.tz("US/Eastern").endOf("day").format();
      assetStates.dailyDue = dailyDueDate >= startOfDay && dailyDueDate <= endOfDay ? false : true;
      assetStates.outOfUse = asset.assetStates.outOfUse;
    }

    return {
      order: order,
      assetStates: assetStates,
      data: {
        "Asset Info": [...HeaderDataList],
        Attributes: [...AttributesList],
      },
    };
  } else {
    {
      let order = ["Asset Info", "Attributes"];
      let assetinfo = [];
      let attributes = [];
      if (asset) {
        assetinfo = [
          { key: "unitId", name: "Unit ID", value: asset.unitId },
          { key: "assetType", name: "Asset Type", value: asset.assetType },
          { key: "desc", name: "Description", value: asset.description },
        ];
        for (let key in asset.attributes) {
          if (typeof asset.attributes[key] == "string")
            attributes.push({ key: key, name: key.charAt(0).toUpperCase() + key.slice(1), value: asset.attributes[key] });
        }
      }
      return { order, data: { "Asset Info": [...assetinfo], Attributes: [...attributes] } };
    }
  }
};

function processAttributesList(attributesList, asset, isPriority) {
  return attributesList
    .filter((atr) => (isPriority ? atr.priority : !atr.priority))
    .map((atr) => ({
      ...atr,
      key: atr.name,
      value: asset.attributes[atr.name],
    }))
    .sort((a, b) => {
      if (isPriority) {
        return a.priority !== b.priority ? a.priority - b.priority : a.name.localeCompare(b.name);
      } else {
        return a.order !== b.order ? a.order - b.order : a.name.localeCompare(b.name);
      }
    });
}



// WEBPACK FOOTER //
// ./src/components/LampAssets/CardView/CardView.jsx